export default __webpack_public_path__ + "static/media/SWT0980.34I-40580_-24040_0.f0128293.jpg";